import React from 'react';
import { useBarcode } from 'react-barcodes';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { getUser } from 'src/utils/Common';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    // width: '189px',
    // height: '94px'
  },

}));


function BarcodeIade({ Barcode, Malzeme, SiparisTarih, Neden, SiparisNo }) {
  const classes = useStyles();
  const { inputRef } = useBarcode({
    value: Barcode,
    options: {
      fontSize: 18
      , flat: true
      , margin: 0
      , height: 60
      , font: "Times New Roman"
      , text: Barcode + ' ' + Malzeme.substring(0, 20)
    }
  });
  const SessionUser = getUser();
  return (
    // <Card className={classes.root}>
    //    <CardHeader
    //     title={<Typography variant="h6">
    //       {SiparisTarih}
    //       <br />
    //       {SessionUser.ServiceShopCode + ' ' + SessionUser.ServiceShopName}
    //     </Typography>}
    //     subheader={<Typography variant="caption" display="block">
    //       {Malzeme.substring(0, 40)}
    //       <br />
    //       {Neden}
    //     </Typography>}
    //   /> 
    //   <CardContent>
    //     <Typography variant="body2">
    <div style={{ font: "Times New Roman", fontSize: 16 }}>
      {SiparisTarih + '-' + Neden + '-' + SiparisNo}
      <br />
      {SessionUser.ServiceShopCode + ' ' + SessionUser.ServiceShopName}
      <br />
      <svg ref={inputRef} />
    </div>
    //     </Typography>
    //   </CardContent>
    // </Card>
  );
};

BarcodeIade.propTypes = {
  className: PropTypes.string,
  EtiketNo: PropTypes.string,
};


export default BarcodeIade;
